<style>
    :root {
        --topbar-size: 56px;
        --bar-bg-color: #161929;
        --bg-color: #1c1f2e;
        --content-padding: 10px;
        --button-size: 32px;
        --videoplaceholder-bg-color: #111;

        --light-text-color: #CDD1D6;

        --panel-bg-color: #242737;

        --state-info: #3b82f6;
        --state-warn: #f59e0b;
        --state-ok:   #22c55e;
        --state-err:  #ef4444;
    }

    .topbar img {
        max-height: 50px;
        max-width: 120px;
    }

    :root {

        --portrait-size: 28px;
    }

    html {
        font-size: 62.5%;
    }

    .pageroot {
        display: flex;
        flex-direction: column;
        height: 100vh;

        font-size: 1.2rem;

        color: var(--light-text-color);
    }

    .topbar, .toolbar {
        padding: 0 var(--content-padding);
        height: var(--topbar-size);
        background-color: var(--bg-color);
        border-bottom: 1px solid rgba(255,255,255,0.06);
        gap: 8px;
    }

    .sidebar > .topbar {
        padding: 10px;
        height: auto;
    }

    .topbar__brand {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
        flex: 1 1 auto;
    }
    .topbar__brand img {
        flex: 0 0 auto;
    }
    .topbar__actions {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 0 0 auto;
    }
    .topbar__user {
        display: flex;
        align-items: center;
        flex: 0 0 auto;
        margin-left: 8px;
    }
    .topbar__action {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
    }
    .topbar__action > label {
        font-size: 10px;
        line-height: 1;
        margin: 0;
        color: rgba(255,255,255,0.6);
        user-select: none;
    }

    .scale-trigger {
        min-width: var(--tap-size);
        height: var(--button-size);
        border-radius: 16px;
        padding: 0 10px;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
    }
    .scale-trigger.dropdown-toggle::after { display: none; }
    .dropdown-item.--checked::before { content: "✓\00a0"; }
    .dropdown-item:not(.--checked)::before { content: "\00a0\00a0\00a0"; }

    .app-nav {
        width: var(--button-size);
        height: var(--button-size);
        padding: 0;
        border: none;
        background: transparent;
        color: rgba(255,255,255,0.55);
        font-size: 20px;
        line-height: 1;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        cursor: pointer;
    }
    .app-nav:hover { background: rgba(255,255,255,0.08); color: white; }
    .app-nav[hidden] { display: none; }
    .topbar__action[hidden], #sound-toggle [hidden] { display: none; }

    :root {
        --tap-size: var(--button-size);
    }
    @media (pointer: coarse) {
        :root { --tap-size: 44px; }
    }
    [v2] button.sq { min-width: var(--tap-size); min-height: var(--tap-size); }

    @media (max-width: 720px) {
        :root { --topbar-size: 44px; }
        .topbar [bolt6only].--hide-mobile { display: none !important; }
        .topbar__user .--s-chip > #user { display: none; }
        .topbar__user .--s-chip { padding-right: 0; background: transparent; }
        .topbar__actions { gap: 4px; }
        .topbar__action > label { display: none; }
        #active-source-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            min-width: 0;
        }
    }

    @media (max-width: 480px) {
        .topbar { padding: 0 6px; gap: 4px; }
        .topbar__brand img { display: none; }
        .topbar__brand { gap: 4px; }
        #active-source-name { flex: 1 1 auto; margin-left: 0; }
        .status-pill .label { display: none; }
        .status-pill .retry { display: none; }
        .status-pill {
            margin-left: 4px;
            padding: 0;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background: transparent;
        }
        .status-pill .dot { width: 10px; height: 10px; flex: 0 0 10px; }
        .topbar__user { margin-left: 0; }
    }

    .maincontentarea {
        flex: 1;
        background: var(--bg-color);
    }

    .vsplit {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .vsplit.--stretch {
        align-items: stretch;
    }

    .leftarea {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .videoarea {
        flex: 1;
        background: var(--videoplaceholder-bg-color);
        position: relative;
    }

    /* Fullscreen (real, or faked on iPhone): hide the topbar but keep the toggle pinned so it can exit. */
    .pseudo-fs .topbar { visibility: hidden; }
    .pseudo-fs .maincontentarea { top: 0 !important; }
    .pseudo-fs #fs-toggle {
        visibility: visible;
        position: fixed;
        top: max(8px, env(safe-area-inset-top));
        right: max(8px, env(safe-area-inset-right));
        z-index: 1100;
        opacity: 0.6;
    }

    .sidebar {
        min-width: 200px;
        width: 200px;
        background: var(--panel-bg-color);
        display: flex;
        flex-direction: column;
    }

    .sidebar.collapsed {
        display: none;

    }

    .title {
        font-weight: boldest;
        color: white;
    }

    b6-viewer {
        width: var(--portrait-size);
        max-width: var(--portrait-size);
        height: var(--portrait-size);
        border: 1.5px solid var(--bar-bg-color);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        background-color: orange;
        color: white;

        overflow: hidden;
        white-space: nowrap;

        user-select: none;
    }

    .--s-chip {
        padding: 6px;
        height: 40px;
        border-radius: 20px;
        background-color: var(--panel-bg-color);

        display: flex;
        align-items: center;
    }

    .toolbar {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .--s-chip b6-viewer {
        margin-right: 12px;
    }

    [no-bg] {
        background: none;
    }

    [spacer] {
        flex: 1;
    }

    #active-source-name {
        margin-left: 8px;
        font-weight: 500;
        font-size: 13px;
        color: rgba(255,255,255,0.65);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
    }

    #canvasroot canvas {
        -webkit-touch-callout:none;
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
        -webkit-tap-highlight-color:rgba(0,0,0,0);
        /* Gestures go to the app (pinch is sent as wheel), so the browser must not zoom or pan the video. */
        touch-action: none;
        position: absolute;
    }

    [v2] button.sq {
        height: var(--button-size);
        width: var(--button-size);

        border-radius: 50%;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    [v2] .--noapps {
        padding: 2rem;
        text-align: center;
    }

    [v2] .app-row {
        width: 100%;
        margin-bottom: 6px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
        padding: 8px 12px;
        color: white;
        position: relative;
    }
    [v2] .app-row.active {
        background-color: rgba(59,130,246,0.15);
        border-color: var(--state-info);
        color: white;
    }
    [v2] .app-row.active::before {
        content: "";
        position: absolute;
        left: 0; top: 6px; bottom: 6px;
        width: 3px;
        background: var(--state-info);
        border-radius: 0 2px 2px 0;
    }
    [v2] .app-row.active::after {
        content: "✓";
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: var(--state-info);
        font-weight: 700;
    }
    [v2] .app-row__name {
        font-weight: 600;
        font-size: 13px;
        line-height: 1.2;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    [v2] .app-row__path {
        font-size: 11px;
        color: rgba(255,255,255,0.55);
        font-weight: 400;
        margin-top: 2px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    [v2] .app-row__separator {
        font-size: 10px;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: rgba(255,255,255,0.45);
        padding: 10px 4px 4px;
        font-weight: 700;
    }
    [v2] .app-empty {
        padding: 2rem 1rem;
        text-align: center;
        color: rgba(255,255,255,0.55);
    }
    [v2] .app-empty__icon  { font-size: 2rem; opacity: 0.35; margin-bottom: 8px; }
    [v2] .app-empty__title { font-weight: 600; margin-bottom: 4px; color: rgba(255,255,255,0.75); }
    [v2] .app-empty__hint  { font-size: 11px; }
    [v2] .app-loading {
        padding: 1.5rem 1rem;
        text-align: center;
        color: rgba(255,255,255,0.55);
        font-size: 12px;
    }
    [v2] .app-ns-select {
        background: rgba(255,255,255,0.04);
        color: var(--light-text-color);
        border: 1px solid #555;
        border-radius: 4px;
        padding: 6px 8px;
        font-size: 12px;
    }

    #offsidebar { width: 300px; max-width: 85vw; }
    .apps-header {
        padding: 10px 12px;
        gap: 8px;
        border-bottom: 1px solid rgba(255,255,255,0.06);
    }
    .apps-search {
        flex: 1;
        margin: 0;
        padding: 7px 12px 7px 36px;
        font-size: 13px;
        border-radius: 8px;
        background: rgba(255,255,255,0.04) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='rgba(255,255,255,0.55)' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'/%3E%3C/svg%3E") no-repeat 12px center;
        border: 1px solid rgba(255,255,255,0.08);
        color: var(--light-text-color);
    }
    .apps-search::placeholder { color: rgba(255,255,255,0.45); }
    .apps-body { padding: 0; }
    .appslist  { padding: 8px 12px 12px; }

    [v2] .apps-pills {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        margin: 0;
        padding: 8px 0;
    }
    [v2] .apps-pills::before {
        content: attr(data-label);
        width: 100%;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: rgba(255,255,255,0.4);
        margin-bottom: 4px;
    }
    [v2] .apps-pills--cluster {
        border-bottom: 1px solid rgba(255,255,255,0.06);
    }
    [v2] .apps-pills--ns {
        padding-bottom: 12px;
    }
    [v2] .apps-pill {
        background: rgba(255,255,255,0.05);
        color: rgba(255,255,255,0.7);
        border: 1px solid transparent;
        border-radius: 12px;
        padding: 3px 10px;
        font-size: 11px;
        font-weight: 500;
        line-height: 1.4;
        cursor: pointer;
        transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
    }
    [v2] .apps-pill:hover {
        background: rgba(255,255,255,0.1);
        color: white;
    }
    [v2] .apps-pill.--active {
        background: rgba(59,130,246,0.18);
        color: white;
        border-color: var(--state-info);
    }

    [v2] input[type="search"] {
        border: none;
        background: transparent;
        margin: 0;
        padding: 7px 8px;
        font-size: 14px;
        color: inherit;
        border: 1px solid transparent;
        border-radius: inherit;
    }

    [v2] input.nosubmit {
        border: 1px solid #555;
        width: 100%;
        padding: 9px 4px 9px 40px;
        background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath  fill='%23ffffff' d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E") no-repeat 13px center;
    }

    [v2] button.btn.active {
        color: #fff;
        background-color: #0d6efd;
    }

    .pulse {
        animation: 1.4s pulse ease-in-out infinite;
    }

    @keyframes pulse {
        0%, 100% { opacity: 0.55; }
        50%      { opacity: 1; }
    }

    .status-pill {
        display: none;
        align-items: center;
        gap: 6px;
        margin-left: 8px;
        padding: 3px 10px 3px 8px;
        height: 22px;
        border-radius: 11px;
        background: rgba(255,255,255,0.06);
        color: rgba(255,255,255,0.85);
        font-size: 11px;
        font-weight: 600;
        user-select: none;
        white-space: nowrap;
        flex: 0 0 auto;
    }

    .status-pill[data-state] {
        display: inline-flex;
    }

    .status-pill[data-state="idle"] {
        display: none;
    }

    .status-pill .dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        flex: 0 0 7px;
        background: var(--state-info);
    }

    .status-pill[data-state="connecting"]   .dot { background: var(--state-info); }
    .status-pill[data-state="waiting"]      .dot { background: var(--state-warn); }
    .status-pill[data-state="reconnecting"] .dot { background: var(--state-warn); }
    .status-pill[data-state="live"]         .dot { background: var(--state-ok);   }
    .status-pill[data-state="error"]        .dot { background: var(--state-err);  }

    .status-pill[data-state="connecting"]   .dot,
    .status-pill[data-state="waiting"]      .dot,
    .status-pill[data-state="reconnecting"] .dot { animation: 1.4s pulse ease-in-out infinite; }

    .status-pill .retry {
        margin-left: 4px;
        background: transparent;
        border: 1px solid rgba(255,255,255,0.4);
        color: white;
        font-size: 10px;
        font-weight: 600;
        padding: 1px 6px;
        border-radius: 8px;
        cursor: pointer;
    }
    .status-pill .retry:hover { background: rgba(255,255,255,0.1); }

    .toast-stack {
        position: absolute;
        bottom: var(--content-padding);
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        gap: 8px;
        z-index: 20;
        pointer-events: none;
        max-width: min(560px, 90vw);
    }

    .toast {
        background: rgba(22,25,41,0.92);
        border-left: 3px solid var(--state-err);
        color: white;
        padding: 10px 14px;
        border-radius: 6px;
        font-size: 13px;
        box-shadow: 0 4px 14px rgba(0,0,0,0.4);
        pointer-events: auto;
        animation: toast-in 0.25s ease-out both;
    }
    .toast.--info { border-left-color: var(--state-info); }
    .toast.--warn { border-left-color: var(--state-warn); }
    .toast .toast-title { font-weight: 700; margin-bottom: 2px; }
    .toast .toast-body  { color: #d6dbe5; font-weight: 400; }

    @keyframes toast-in {
        from { opacity: 0; transform: translateY(8px); }
        to   { opacity: 1; transform: translateY(0); }
    }
</style>

<script>
</script>

<div class="pageroot" style="display:flex;flex-direction:column;position:relative;" v2 data-bs-theme="dark">

    <div class="topbar vsplit">
        <div class="topbar__brand">
            <img src="logo.png" alt="">
            <button class="app-nav" type="button" id="app-prev" title="Previous app" aria-label="Previous app" hidden>‹</button>
            <span id="active-source-name"></span>
            <button class="app-nav" type="button" id="app-next" title="Next app" aria-label="Next app" hidden>›</button>
            <div class="status-pill" id="stream-status" role="status" aria-live="polite">
                <span class="dot"></span>
                <span class="label">Idle</span>
            </div>
        </div>

        <div class="topbar__actions">
            <div bolt6only class="topbar__action">
                <div class="dropdown">
                    <button class="btn btn-outline-secondary scale-trigger dropdown-toggle" type="button"
                            id="scaleBtn" data-bs-toggle="dropdown" aria-expanded="false" title="Scale">
                        <span id="scaleLabel">1×</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="scaleBtn" id="scaleMenu">
                        <li><button class="dropdown-item" type="button" data-scale="0.5">0.5×</button></li>
                        <li><button class="dropdown-item" type="button" data-scale="0.75">0.75×</button></li>
                        <li><button class="dropdown-item" type="button" data-scale="1">1×</button></li>
                        <li><button class="dropdown-item" type="button" data-scale="1.2">1.2×</button></li>
                        <li><button class="dropdown-item" type="button" data-scale="1.5">1.5×</button></li>
                    </ul>
                </div>
                <label>Scale</label>
            </div>

            <div bolt6only class="topbar__action">
                <button class="btn btn-secondary sq" id="btnViewOnly" title="Take control" aria-label="Take control">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 22C16.13 22 19.5 18.63 19.5 14.5V9.5C19.5 5.37 16.13 2 12 2C7.87 2 4.5 5.37 4.5 9.5V14.5C4.5 18.63 7.87 22 12 22Z"
                              stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 11C11.17 11 10.5 10.33 10.5 9.5V7.5C10.5 6.67 11.17 6 12 6C12.82 6 13.5 6.67 13.5 7.5V9.5C13.5 10.33 12.82 11 12 11Z"
                              stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 6V2" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </button>
                <label>Take Control</label>
            </div>

            <b6-viewers-list class="vsplit"></b6-viewers-list>

            <div class="topbar__action" id="sound-action" hidden>
                <button class="btn btn-outline-secondary sq" type="button" id="sound-toggle"
                        title="Turn sound on" aria-label="Turn sound on" aria-pressed="false">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 9.5V14.5H8L13 19V5L8 9.5H4Z" stroke="#ffffff" stroke-width="1.5"
                              stroke-linejoin="round"/>
                        <path class="sound-on" d="M16.5 8.5C17.5 9.5 18 10.7 18 12C18 13.3 17.5 14.5 16.5 15.5M19 6C20.6 7.6 21.5 9.7 21.5 12C21.5 14.3 20.6 16.4 19 18"
                              stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" hidden/>
                        <path class="sound-off" d="M16.5 9.5L21.5 14.5M21.5 9.5L16.5 14.5" stroke="#ffffff"
                              stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </button>
                <label>Sound</label>
            </div>
            <div class="topbar__action">
                <button class="btn btn-outline-secondary sq" type="button" id="fs-toggle"
                        title="Toggle fullscreen" aria-label="Toggle fullscreen">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 9V6.5C2 4.01 4.01 2 6.5 2H9" stroke="#ffffff" stroke-width="1.5"
                              stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 2H17.5C19.99 2 22 4.01 22 6.5V9" stroke="#ffffff" stroke-width="1.5"
                              stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22 16V17.5C22 19.99 19.99 22 17.5 22H16" stroke="#ffffff" stroke-width="1.5"
                              stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9 22H6.5C4.01 22 2 19.99 2 17.5V15" stroke="#ffffff" stroke-width="1.5"
                              stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <label>Fullscreen</label>
            </div>
            <div class="topbar__action">
                <button class="btn btn-outline-secondary sq" id="offSidebarToggle" data-bs-toggle="offcanvas"
                        aria-expanded="false" data-bs-target="#offsidebar"
                        title="Apps" aria-label="Open apps drawer">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3"  y="3"  width="7" height="7" rx="1.5" stroke="#ffffff" stroke-width="1.5"/>
                        <rect x="14" y="3"  width="7" height="7" rx="1.5" stroke="#ffffff" stroke-width="1.5"/>
                        <rect x="3"  y="14" width="7" height="7" rx="1.5" stroke="#ffffff" stroke-width="1.5"/>
                        <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="#ffffff" stroke-width="1.5"/>
                    </svg>
                </button>
                <label>Apps</label>
            </div>
        </div>

        <div class="topbar__user">
            <div class="--s-chip">
                <div id="user" class="vsplit"></div>
                <span spacer></span>

                <div class="dropdown">
                    <button class="btn btn-outline-secondary dropdown-toggle sq" type="button" id="uactionddbutton"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="uactionddbutton">
                        <h6 class="dropdown-header">Stream server</h6>
                        <div id="relayMenu"></div>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#" id="logout">Logout</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="maincontentarea vsplit --stretch"
         style="top:var(--topbar-size);left:0;right:0;bottom:0;position:absolute;">
        <div class="leftarea">
            <div class="videoarea" id="workingarea">

                <div class="offcanvas offcanvas-end sidebar" tabindex="-1" id="offsidebar">
                    <div class="offcanvas-header apps-header">
                        <input class="nosubmit apps-search" type="search" placeholder="Search apps…" id="offAppsfilter">
                        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>
                    <div class="offcanvas-body apps-body">
                        <div class="appslist" data-b6-filterfrom="#offAppsfilter" data-b6-filterkey="app">
                        </div>
                    </div>
                </div>

                <div id="canvasroot" style="position:relative;width:100%;height:100%;">
                </div>

                <div class="toast-stack" id="toast-stack"></div>
            </div>
        </div>
    </div>
</div>

<template id="template-app-card">
    <a style="width:100%" class="btn btn-secondary m-3" href="#" data-app="{{appid}}" id="idapp-{{appid}}">{{appid}}</a>
</template>
